import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const RefundRequestTypeModel = t.model('RefundRequestTypeModel', {
  id: t.string,
  name: t.string,
  description: t.string,
  status: t.string,
});

export const RefundRequestTypesModel = t
  .model('RefundRequestTypesModel', {
    list: t.array(RefundRequestTypeModel),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default RefundRequestTypesModel;
